export function setLocal(name, value) {
  let data = value;
  if (typeof data !== 'string') {
    if (typeof data === 'undefined') {
      data = null;
    } else {
      data = JSON.stringify(data);
    }
  }
  window.localStorage.setItem(name, data);
}

export function getLocal(name) {
  const data = window.localStorage.getItem(name);
  try {
    return JSON.parse(data);
  } catch (e) {
    return data;
  }
}

export function setSession(name, value) {
  let data = value;
  if (typeof data !== 'string') {
    if (typeof data === 'undefined') {
      data = null;
    } else {
      data = JSON.stringify(data);
    }
  }
  window.sessionStorage.setItem(name, data);
}

export function getSession(name) {
  const data = window.sessionStorage.getItem(name);
  try {
    return JSON.parse(data);
  } catch (e) {
    return data;
  }
}

export function remove(name) {
  if (window.sessionStorage.getItem(name)) {
    window.sessionStorage.removeItem(name);
  }
  if (window.localStorage.getItem(name)) {
    window.localStorage.removeItem(name);
  }
}

export function clear() {
  window.sessionStorage.clear();
  window.localStorage.clear();
}

export default {
  setLocal,
  getLocal,
  setSession,
  getSession,
  remove,
  clear
};
